export default __webpack_public_path__ + "static/media/img-08.87f3eaf7.jpg";